// Rep-role narrowing offered above the table. ALL is the default, per the story.
enum RoleFilter {
  ALL = "all",
  OWNERS = "owners",
  MANAGERS = "managers",
  MEMBERS = "members",
}

export default RoleFilter;
